import { useFeatureFlags } from '@usap/core';

const useIsInvisibleCaptcha = () => {
    const { f42 } = useFeatureFlags();
    const f42Enabled = new Set(['b', '1', 'on', 'true']);

    return typeof f42 === 'string' && f42Enabled.has(f42);
};

export default useIsInvisibleCaptcha;